import { useState } from "react";
import FacetIcon from "./FacetIcon";
import { isFes } from "../../utils/diffentLayoutCheck";

const channelIndex = process.env.REACT_APP_PROJECT_INDEX || undefined;

const Facet = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleFilterClick = (val) => {
    props.filtersHandler(props.id, val);
  };
  const checkIfActive = (f) => {
    if (!props.selections[props.id]) {
      return false;
    } else {
      return props.selections[props.id].includes(f);
    }
  };

  const fesTopicMapping = (topic) => {
    const mapping = {
      1: "Algorithmic Management",
      2: "Automation & Labour Markets",
      3: "Digital political economy",
    };
    if (
      channelIndex &&
      channelIndex === "fes" &&
      props.label.toLowerCase() === "topic"
    ) {
      return mapping[topic];
    }
    return topic;
  };

  const otherMappings = (val) => {
    const mapping = {
      "the machinist": "Best of technology",
      "the progressive": "Best of political economy",
      "the cosmopolitan": "Best of world",
      "the activist": "Best of social justice",
      "the intellectual": "Best of arts & culture",
      "the professor": "Best of academic articles",
      "the essayist": "Best of journalism",
      "the chatterbox": "Best of podcasts",
      "the watchdog": "Best of videos",
      "the polymath": "All highlights",
      "the provocateur": "Best of French",
      "the besserwisser": "Best of German",
      "the aficionado": "Best of spanish",
      "the maestro": "Best of italian",
      "the sábio": "Best of portuguese",
      academic: "Articles",
      books: "Books",
      "journalism & essays": "Journalism",
      podcasts: "Podcasts",
      "reports, dissertations, & miscellaneous": "Documents",
      videos: "Videos",
      document:'Documents',
      video: 'Videos',
      podcast: 'Podcasts',
      book: 'Books',
      article: 'Articles'
    };
    return mapping[val.toLowerCase()] ? mapping[val.toLowerCase()] : val;
  };
  const sortedFacets = () => {
    if (channelIndex === "syllabus" && props.label.toLowerCase() === "series") {
      const indexes = {
        "the machinist": 0,
        "the progressive": 1,
        "the cosmopolitan": 2,
        "the activist": 3,
        "the intellectual": 4,
        "the professor": 5,
        "the essayist": 6,
        "the chatterbox": 7,
        "the watchdog": 8,
        "the polymath": 9,
        "the provocateur": 10,
        "the besserwisser": 11,
        "the aficionado": 12,
        "the maestro": 13,
        "the sábio": 14,
      };
      const sortedSeries = new Array(props.facetValues.length)
      props.facetValues.map(s=>sortedSeries[indexes[s.toLowerCase()]] = s);
      return sortedSeries
    }
    return props.facetValues;
  };
  return (
    <div className="w-full border-b-[1px] border-b-black border-dotted ">
      <div className="w-full flex flex-row justify-between items-center py-5">
        <span className="font-bold uppercase text-filter-title whitespace-nowrap">
          {props.label}
        </span>
        <span
          className={`transition-all duration-400 cursor-pointer ${
            isOpen ? "-rotate-45" : ""
          }`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <FacetIcon />
        </span>
      </div>
      {isOpen ? (
        <div className="flex flex-col items-start justif-start uppercase max-h-[150px] overflow-y-auto pb-2.5">
          {sortedFacets().map((f) => (
            <div
              className={`cursor-pointer hover:opacity-50 text-left text-filter-value ${
                checkIfActive(f.toLowerCase())
                  ? "text-primary font-bold"
                  : "text-grey"
              }`}
              onClick={() => handleFilterClick(f)}
              key={f}
            >
              {isFes() ? fesTopicMapping(f) : otherMappings(f)}
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default Facet;
